import { useNavigate } from 'react-router';
import { isPlanningPath, previousPath } from '../../lib/navHistory';

/**
 * Retour au planning : retour en arrière si la page précédente de l'app est une page du planning (filtres et semaine
 * conservés), sinon le planning lui-même (venu de Mon compte, d'un lien direct ou d'un autre onglet).
 */
export function useBackToPlanning() {
  const navigate = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0 && isPlanningPath(previousPath())) navigate(-1);
    else navigate('/');
  };
}
